import { type FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { QuotaForecastingHistogramBucket } from "../../types/quotaForecasting";

import { useTheme } from "../../context/ThemeContext";
import { ContentCard } from "../common/ContentCard";
import { Text } from "../common/Text";

export interface QuotaForecastingHistogramChartProps {
  title: string;
  buckets: QuotaForecastingHistogramBucket[];
  emptyText: string;
  fill: string;
}

export const QuotaForecastingHistogramChart: FC<
  QuotaForecastingHistogramChartProps
> = ({ title, buckets, emptyText, fill }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <ContentCard className="space-y-3">
      <Text variant="label">{title}</Text>
      {buckets.length === 0 ? (
        <Text>{emptyText}</Text>
      ) : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={buckets}>
              <CartesianGrid
                stroke={isDark ? "rgba(255,255,255,0.08)" : "#e5e7eb"}
                strokeDasharray="3 3"
              />
              <XAxis
                dataKey="label"
                tick={{ fontSize: 10 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                tick={{ fontSize: 11 }}
                tickLine={false}
                axisLine={false}
              />
              <Tooltip
                formatter={(value: number | undefined) =>
                  (value ?? 0).toLocaleString()
                }
              />
              <Bar dataKey="count" fill={fill} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </ContentCard>
  );
};
